import { PGService } from '../../Remote/PowerGym';

const STATE_KEY = 'as_link_state';

/** Nonce que vuelve dentro de la afirmación: /vincular lo compara antes de aceptar nada. */
const newState = () => {
    const bytes = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    return Array.from(bytes, (b) => ('0' + b.toString(16)).slice(-2)).join('');
};

/**
 * Arranca el puente: pide la precarga al core y manda al socio al Auth Service. Al terminar, el AS
 * vuelve a `/vincular#assertion=…` de este mismo club.
 * @returns {Promise<{ok: boolean, message?: string}>}
 */
export async function startAccountLink() {
    const res = await PGService.linkAccountPrefill();
    if (!res || !res.success || !res.prefill || !res.link_url) {
        return { ok: false, message: (res && res.message) || null };
    }
    const state = newState();
    localStorage.setItem(STATE_KEY, state);
    const returnUrl = `${window.location.origin}/vincular`;
    const url = `${res.link_url}?return_url=${encodeURIComponent(returnUrl)}&state=${encodeURIComponent(state)}&prefill=${encodeURIComponent(res.prefill)}`;
    window.location.href = url;
    return { ok: true };
}

/** Lee `#assertion=` de la URL de retorno y verifica el `state` guardado antes de salir. */
export function readReturnedAssertion() {
    const hash = window.location.hash || '';
    const match = /assertion=([^&]+)/.exec(hash);
    if (!match) {
        return { assertion: null, stateOk: false };
    }
    const assertion = decodeURIComponent(match[1]);
    const expected = localStorage.getItem(STATE_KEY);
    let stateOk = false;
    try {
        const body = assertion.split('.')[1] || '';
        const padded = body.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((body.length + 3) % 4);
        const payload = JSON.parse(atob(padded));
        stateOk = Boolean(expected) && payload.state === expected;
    } catch (e) {
        stateOk = false;
    }
    return { assertion, stateOk };
}

export function clearReturnState() {
    localStorage.removeItem(STATE_KEY);
}
